import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { getStoreInfoByIdFn } from "@/server-fns/booking/serverFns";
import { generateStoreSlug } from "@/utils/generateStoreSlug";

export const Route = createFileRoute("/$storeId/")({
    loader: async ({ params }) => {
        const storeData = await getStoreInfoByIdFn({
            data: { storeId: params.storeId.toUpperCase() },
        });
        if (!storeData) throw notFound();
        const slug = storeData.slug || generateStoreSlug(storeData.name);
        throw redirect({
            to: "/$storeId/$slug",
            params: { storeId: params.storeId.toUpperCase(), slug },
            statusCode: 301,
        });
    },
    component: () => null,
});
